import { create } from 'zustand'
import { persist } from 'zustand/middleware'

let initialCart = {
    category: null,
    status: null,
    product: null,
    session: null,
    reward: null,
    error: null,
    dpcStep: 0,
    productsLoaded: false,
};

const useCart = create(persist(
    (set) => ({

        cart: initialCart,

        setCart: (props) => set(state => {

            let newCart = {...state.cart}

            Object.assign(newCart, props)

            let newState = {...state, cart: newCart}
            
            return newState
        }),

        resetCart: () => set(state => {
            
            return {...state, cart: initialCart}
        }),
    
    }),

    {
        name: 'applyStore',
    }
))


export default useCart;